export default "__VITE_ASSET__BrU$kKQk__"